import React from "react";
import PropTypes from "prop-types";
import config from "../config";

export default class Title extends React.Component {
  componentDidMount() {
    this.oldTitle = document.title;
    const { title } = this.props;
    if (title) {
      document.title = title + " | " + config.appName;
    }
  }

  componentDidUpdate() {
    if (this.props.title) {
      document.title = this.props.title + " | " + config.appName;
    }
  }

  componentWillUnmount() {
    document.title = this.oldTitle;
  }

  render() {
    return null;
  }
}

Title.propTypes = {
  title: PropTypes.string
};
